module.exports = __webpack_public_path__ + "static/media/w3s.82c983aa.svg";